import { UseExternalRPCQueryOptions, useRPCQuery } from '@/lib/api/request/use-rpc-query';

type WhoamiRequest = Record<string, never>;

type WhoamiResponse = {
  auth: {
    userId: string;
    roles: string[];
  };
  captchaDisabled?: boolean;
};

export function useWhoami({
  params,
  ...opts
}: UseExternalRPCQueryOptions<WhoamiResponse, WhoamiRequest>) {
  return useRPCQuery({
    ...opts,
    queryKey: ['ignoreLoading'],
    method: useWhoami.method,
    params,
  });
}

useWhoami.method = 'auth:who-am-i';
